<template>
    
    <div class="main">
        <c-panel>
            <form-parametro-rede></form-parametro-rede>
        </c-panel>
    </div>
    
</template>
<script>

import formParametroRede from "./form"

export default {
    methods:{ },
    components:{ formParametroRede }
}
</script>
